module.exports = __webpack_public_path__ + "static/work-day-scheduler-1981c21f929ff83283eb0521b3334054.jpg";